<script setup lang="ts">
import {reactive, ref} from 'vue'
import {ComponentSize, dayjs, FormInstance, FormRules} from 'element-plus'
import AddSingleFile from "components/dialog/common/innner/AddSingleFile.vue";
import {SaveRecordSection, SectionInfo} from "@/types";

const aheadRef = ref<InstanceType<typeof AddSingleFile>>();
const pdfRef = ref<InstanceType<typeof AddSingleFile>>();
const consolidateRef = ref<InstanceType<typeof AddSingleFile>>();
const is_playback = ref(0)
const is_try_study = ref(0)
const try_study_second =  ref(0)
const view_start_time = ref<Date>()
const view_end_time = ref<Date>()

interface RuleForm {
  title: string
}

const formSize = ref<ComponentSize>('default')
const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive<RuleForm>({
  title: '',
})

const rules = reactive<FormRules<RuleForm>>({
  title: [
    {required: true, message: '请输入章节标题', trigger: 'blur'},
    {min: 1, max: 30, message: '标题长度在 1 到 30 个字符', trigger: 'blur'},
  ]
})

const init = (sectionInfo?: SectionInfo) => {
  if (sectionInfo) {
    console.log(sectionInfo);
    ruleForm.title = sectionInfo.title
    is_playback.value = sectionInfo.is_playback
    is_try_study.value = sectionInfo.is_try_study
    try_study_second.value = sectionInfo.try_study_second
    if (sectionInfo.view_start_time) {
      view_start_time.value = new Date(sectionInfo.view_start_time * 1000)
    }
    if (sectionInfo.view_end_time) {
      view_end_time.value = new Date(sectionInfo.view_end_time * 1000)
    }
    aheadRef.value?.initFileList(sectionInfo.ahead_data)
    pdfRef.value?.initFileList(sectionInfo.pdf_data)
    consolidateRef.value?.initFileList(sectionInfo.consolidate_data)
  }
}

const emit = defineEmits<{
  (e: "onSubmit", info: SaveRecordSection): void,
  (e: "onClose"): void
}>()

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      let start_time = undefined, end_time = undefined
      if (is_playback.value === 1) {
        if (view_start_time.value) {
          start_time =dayjs(view_start_time.value).startOf('minutes').unix()
        }
        if (view_end_time.value) {
          end_time = dayjs(view_end_time.value).endOf('minutes').unix()
        }
      }
      emit('onSubmit', {
        title: ruleForm.title,
        ahead_data: aheadRef.value?.getFileId(),
        pdf_data: pdfRef.value?.getFileId(),
        consolidate_data: consolidateRef.value?.getFileId(),
        is_playback: is_playback.value,
        view_start_time: start_time,
        view_end_time: end_time,
        is_try_study:is_try_study.value,
        try_study_second:try_study_second.value
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}

const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.resetFields()
  emit('onClose')
}

defineExpose({
  init
})
</script>

<template>
  <el-form
      ref="ruleFormRef"
      style="max-width: 40rem"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm"
      :size="formSize"
      status-icon
  >
    <el-form-item label="章节标题" prop="title">
      <el-input v-model="ruleForm.title" placeholder="请输入章节标题" maxlength="30" show-word-limit/>
    </el-form-item>
    <el-form-item label="课前导学">
      <add-single-file ref="aheadRef"/>
    </el-form-item>
    <el-form-item label="课堂讲义">
      <add-single-file ref="pdfRef"/>
    </el-form-item>
    <el-form-item label="课后巩固">
      <add-single-file ref="consolidateRef"/>
    </el-form-item>
    <el-form-item label="时效设置">
      <el-radio-group v-model="is_playback">
        <el-radio-button label="有时效" :value="1"/>
        <el-radio-button label="无时效" :value="0"/>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="观看时效" v-if="is_playback">
      <el-date-picker
          v-model="view_start_time"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          placeholder="请选择开始时间(可不填)"
      />
      <span class="ml-1rem mr-1rem">~</span>
      <el-date-picker
          v-model="view_end_time"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          placeholder="请选择结束时间(可不填)"
      />
    </el-form-item>
    <div v-if="is_playback">
      <div class="mb-10px">* 上传视频后，购买该课程的学生可在指定时效内，观看章节内容；</div>
      <div class="mb-10px">
        * 选择恰当的时效，学生可在该时间内观看视频，超过时间后将无法观看。
      </div>
    </div>

    <el-form-item label="试学设置">
      <el-radio-group v-model="is_try_study">
        <el-radio-button label="有试学" :value="1"/>
        <el-radio-button label="无试学" :value="0"/>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="观看时效" v-if="is_try_study">
      <el-input v-model="try_study_second" maxlength="30" show-word-limit/>
    </el-form-item>
    <div v-if="is_try_study">
      <div class="mb-10px">* 请输入试看秒数，0代表整章节试看</div>
    </div>

    <el-form-item>
      <el-button type="primary" @click="submitForm(ruleFormRef)">
        修改信息
      </el-button>
      <el-button @click="resetForm(ruleFormRef)">取消</el-button>
    </el-form-item>
  </el-form>
</template>

<style scoped>
</style>
